import React from 'react'

//[mh] RITM0249443: AU-only planned maintenance, 6-9 November 2026. Shown on the AU landing page until the window
// ends, then hidden automatically so no second deploy is needed to remove it.
export const SCHEDULED_OUTAGE = {
    end: Date.parse('2026-11-09T08:30:00+11:00'),
    start: 'Friday, 6 November 2026 at 5:00 PM AEDT',
    finish: 'Monday, 9 November 2026 at 8:30 AM AEDT'
}

export const isScheduledOutageNoticeVisible = (isNz, now = Date.now(), outage = SCHEDULED_OUTAGE) =>
    !isNz && now < outage.end

export const ScheduledOutageNotice = () => (
    <div className="outage-banner" role="status">
        MyCanon Business will not be available due to planned maintenance this weekend. Details of the outage are as
        follows:
        <ul>
            <li>Start: {SCHEDULED_OUTAGE.start}</li>
            <li>End: {SCHEDULED_OUTAGE.finish}</li>
        </ul>
        Please contact our helpdesk 13 13 83 if you require assistance.
        <br/>
        Thank you.
    </div>
)
